<template>
  <c-input
    as="multiselect"
    :class="invalidClass"
    v-model="selected"
    placeholder="Select"
    :preselect-first="prependAll"
    :show-labels="false"
    :options="options"
    :multiple="multiple"
    label="name"
    track-by="id"
  />
</template>

<script>
import { get, call } from 'vuex-pathify'
import { useIsInvalid } from '@chameleon/chameleon-vue'

export default {
  mixins: [useIsInvalid],

  props: {
    value: {
      type: [Number, Array],
      default: null
    },
    prependAll: Boolean,
    multiple: {
      type: Boolean,
      default: false
    },
    excludeIds: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    mediaOwners: get('lists/mediaOwners/mediaOwners'),

    options () {
      let options = [...this.mediaOwners]

      if (this.prependAll && !this.multiple) {
        options.unshift({ name: 'All', id: null })
      }

      if (this.excludeIds && this.excludeIds.length) {
        options = options.filter(({ id }) => !this.excludeIds.includes(id))
      }

      return options
    },

    selected: {
      get () {
        if (this.multiple) {
          const ids = Array.isArray(this.value) ? this.value : []
          return this.options.filter(({ id }) => ids.includes(id))
        } else {
          return this.options.find(({ id }) => id === this.value)
        }
      },

      set (value) {
        if (this.multiple) {
          this.$emit('input', Array.isArray(value) ? value.map(option => option.id) : [])
        } else {
          this.$emit('input', value ? value.id : null)
        }
      }
    }
  },

  async created () {
    await this.getMediaOwners()
  },

  methods: {
    getMediaOwners: call('lists/mediaOwners/getMediaOwners')
  }
}
</script>
